import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "preview", "submit"]

  select(event) {
    const selectedId = event.target.value

    // Enable submit button
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }

    // Highlight selected option
    this.optionTargets.forEach(option => {
      const radio = option.querySelector('input[type="radio"]')
      if (radio && radio.value === selectedId) {
        option.classList.add("border-blue-400", "bg-blue-50")
        option.classList.remove("border-gray-200")
      } else {
        option.classList.remove("border-blue-400", "bg-blue-50")
        option.classList.add("border-gray-200")
      }
    })

    // Fetch preview via turbo stream
    this.loadPreview(selectedId)
  }

  async loadPreview(workflowId) {
    if (!this.hasPreviewTarget) return

    try {
      const response = await fetch(`/project_workflows/${workflowId}/preview`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      // Silently fail - preview is not critical
    }
  }
}
